module.exports = __webpack_public_path__ + "media/Notification2.2a10746d.wav";